module.exports = __webpack_public_path__ + "static/RR5-e3463d49ffbdb0ebacc672b2fb15c414.jpg";